import { BehaviorSubject } from 'rxjs';
import { take } from 'rxjs/operators';
import { CalendarNormalModel } from '../core/models/calendar-normal.model';
import { CalendarModel } from '../core/models/calendar.model';
import { CheckboxModel } from '../core/models/checkbox.model';
import { ChipsModel } from '../core/models/chips.model';
import { InputModel } from '../core/models/input.model';
import { RadioPointModel } from '../core/models/radio-point.model';
import { SelectModel } from '../core/models/select.model';
import { commondRowLimits, commondSelectOptionsList, Numbers } from './constants';
import { setBtnTooltip, setCheckboxModel, setSelectModel, setSelectOptions, setSelectValue, setTableRow } from './labels.utils';
import { getAllInsuredSameFamiliarUnit, getBussines, getCodePromotional,
         getCurrentlyTraveling, getDerogationCodes, getDocumentNumber,
         getDocumentType, getEmFirstSurname, getEmName,
         getFirstSurname, getHasCodeDerogation, getHasPetsInsurance, getInsuredOlderThan70years,
         getInsuredsPlayRiskSports, getListDataDocumentNumber, getListDataDocumentType,
         getListDataFirstSurname, getListDataName, getNumberOfInsured,
         getParticular, getSeccondSurname, getTypeOwner } from './form-utils-extended';

/**
 * @description funcion para obtener los modelos del fomulario
 * @param linkFormValue foumulario que se usa
 * @returns modelo de input
 */
const getListDataSeccondSurname: () => InputModel = (): InputModel => {
  return new InputModel({
    linkFormPath: ['secondSurname'],
    label: 'form1.listdata.second-surname',
    value: '',
    required: false
  });
};
/**
 * @description funcion para obtener los modelos del fomulario
 * @param linkFormValue foumulario que se usa
 * @returns modelo de input
 */
const getEmSecondSurname: (linkFormValue: string) => InputModel = (linkFormValue: string): InputModel => {
  return new InputModel({
    linkFormPath: [linkFormValue, 'emergencyContact', 'secondSurname'],
    label: 'form1.emergencyContact.second-surname',
    requiredText: 'form1.default-error'
  });
};
/**
 * @description funcion para obtener los modelos del fomulario
 * @param linkFormValue foumulario que se usa
 * @returns modelo de input
 */
const getEmail: (linkFormValue: string) => InputModel = (linkFormValue: string): InputModel => {
  return new InputModel({
    linkFormPath: [linkFormValue, 'insuredData', 'email'],
    label: 'form1.email',
    required: true,
    requiredText: 'form1.default-error',
    emailError: 'form1.default-email-error'
  });
};
/**
 * @description funcion para obtener los modelos del fomulario
 * @param linkFormValue foumulario que se usa
 * @returns modelo de input
 */
const getListDataEmail: () => InputModel = (): InputModel => {
  return new InputModel({
    linkFormPath: ['email'],
    label: 'form1.step4.email',
    emailError: 'form1.default-email-error'
  });
};
/**
 * @description funcion para obtener los modelos del fomulario
 * @returns modelo de calendar
 */
const getDateBorn: () => CalendarNormalModel = (): CalendarNormalModel => {
  return new CalendarNormalModel({
    linkFormPath: ['dateBorn'],
    placeholder: 'form1.listdata.dateBorn',
    icon: 'icon-date'
  });
};
/**
 * @description funcion para obtener los modelos del fomulario
 * @param linkFormValue foumulario que se usa
 * @returns modelo de select
 */
const getPrefix: (linkFormValue: string) => SelectModel = (linkFormValue: string): SelectModel => {
  return new SelectModel({
    linkFormPath: [linkFormValue, 'insuredData', 'prefix'],
    select: {
      label: 'form1.prefix',
      error: 'form1.default-error'
    },
    options: {
      default: {
        selected: 'España (+34)',
        label: 'España (+34)',
        disabled: false
      },
      list: []
    }
  });
};
/**
 * @description funcion para obtener los modelos del fomulario
 * @param linkFormValue foumulario que se usa
 * @returns modelo de select
 */
const getEMPrefix: (linkFormValue: string) => SelectModel = (linkFormValue: string): SelectModel => {
  return new SelectModel({
    linkFormPath: [linkFormValue, 'emergencyContact', 'prefix'],
    select: {
      label: 'form1.prefix',
      error: 'form1.default-error'
    },
    options: {
      default: {
        selected: 'España (+34)',
        label: 'España (+34)',
        disabled: false
      },
      list: []
    }
  });
};
/**
 * @description funcion para obtener los modelos del fomulario
 * @param linkFormValue foumulario que se usa
 * @returns modelo de input
 */
const getTelephone: (linkFormValue: string) => InputModel = (linkFormValue: string): InputModel => {
  return new InputModel({
    linkFormPath: [linkFormValue, 'insuredData', 'telephone'],
    label: 'form1.telephone',
    required: true,
    requiredText: 'form1.default-error',
    maxlength: '9',
    maxlengthText: 'form1.default-maxlenght-error',
    onlynumberError: 'form1.default-onlynum-error'
  });
};
/**
 * @description funcion para obtener los modelos del fomulario
 * @param linkFormValue foumulario que se usa
 * @returns modelo de input
 */
const getEmTelephone: (linkFormValue: string) => InputModel = (linkFormValue: string): InputModel => {
  return new InputModel({
    linkFormPath: [linkFormValue, 'emergencyContact', 'telephone'],
    label: 'form1.emergencyContact.telephone',
    requiredText: 'form1.default-error',
    maxlength: '9',
    maxlengthText: 'form1.default-maxlenght-error',
    onlynumberError: 'form1.default-onlynum-error'
  });
};
/**
 * @description funcion para obtener los modelos del fomulario
 * @param linkFormValue foumulario que se usa
 * @returns modelo de input
 */
const getRelationWithInsured: (linkFormValue: string) => InputModel = (linkFormValue: string): InputModel => {
  return new InputModel({
    linkFormPath: [linkFormValue, 'emergencyContact', 'relationWithInsured'],
    label: 'form1.emergencyContact.relationWithInsured',
    requiredText: 'form1.default-error'
  });
};
/**
 * @description funcion para obtener los modelos del fomulario
 * @param linkFormValue foumulario que se usa
 * @returns modelo de checkbox
 */
const getAcceptTerms: (linkFormValue: string) => CheckboxModel = (linkFormValue: string): CheckboxModel => {
  return new CheckboxModel(setCheckboxModel([linkFormValue, 'emergencyContact', 'acceptTerms'],
  'form1.emergencyContact.acceptTerms', false, 'form1.default-error')
  );
};
/**
 * @description funcion para obtener los modelos del fomulario
 * @param linkFormValue foumulario que se usa
 * @returns modelo de checkbox
 */
const getAdequacyOfProduct: (linkFormValue: string) => CheckboxModel = (linkFormValue: string): CheckboxModel => {
  return new CheckboxModel(setCheckboxModel([linkFormValue, 'emergencyContact',
  'adequacyOfProduct'], 'form1.emergencyContact.adequacyOfProduct', true, 'form1.default-error'));
};
/**
 * @description funcion para obtener los modelos del fomulario
 * @param linkFormValue foumulario que se usa
 * @returns modelo de radio-point
 */
const getTreatmentOfData: (linkFormValue: string) => RadioPointModel = (linkFormValue: string): RadioPointModel => {
  return new RadioPointModel({
    linkFormPath: [linkFormValue, 'termsList'],
    id: '1',
    description: 'form1.emergencyContact.treatmentOfData',
    optionTwoSelectedSubText: 'form1.emergencyContact.treatmentOfDataConsent',
    optionOneText: 'form1.emergencyContact.yes',
    optiontwoText: 'form1.emergencyContact.no',
    checked: true
  });
};
/**
 * @description funcion para obtener los modelos del fomulario
 * @param linkFormValue foumulario que se usa
 * @returns modelo de radio-point
 */
const getAdvertisingInternationalSOS: (linkFormValue: string) => RadioPointModel = (linkFormValue: string): RadioPointModel => {
  return new RadioPointModel({
    linkFormPath: [linkFormValue, 'termsList'],
    id: '15',
    description: 'form1.emergencyContact.sendAdvertisingInternationalSOS',
    optionOneText: 'form1.emergencyContact.yes',
    optiontwoText: 'form1.emergencyContact.no',
    checked: false
  });
};
/**
 * @description funcion para obtener los modelos del fomulario
 * @param linkFormValue foumulario que se usa
 * @returns modelo de radio-point
 */
const getAdvertisingByThirdParties: (linkFormValue: string) => RadioPointModel = (linkFormValue: string): RadioPointModel => {
  return new RadioPointModel({
    linkFormPath: [linkFormValue, 'termsList'],
    id: '9',
    description: 'form1.emergencyContact.sendAdvertisingByThirdParties',
    optionOneText: 'form1.emergencyContact.yes',
    optiontwoText: 'form1.emergencyContact.no',
    checked: false
  });
};
/**
 * @description funcion para obtener los modelos del fomulario
 * @param linkFormValue foumulario que se usa
 * @returns modelo de radio-point
 */
const getAdvertisingEventsAndNews: (linkFormValue: string) => RadioPointModel = (linkFormValue: string): RadioPointModel => {
  return new RadioPointModel({
    linkFormPath: [linkFormValue, 'termsList'],
    id: '16',
    description: 'form1.emergencyContact.sendAdvertisingEventsAndNews',
    optionOneText: 'form1.emergencyContact.yes',
    optiontwoText: 'form1.emergencyContact.no',
    checked: false
  });
};
/**
 * @description funcion para obtener los modelos del fomulario
 * @param linkFormValue foumulario que se usa
 * @returns modelo de input
 */
const getDirecction: (linkFormValue: string) => InputModel = (linkFormValue: string): InputModel => {
  return new InputModel({
    linkFormPath: [linkFormValue, 'insuredData', 'postalCode'],
    label: 'form1.postalcode',
    required: true,
    requiredText: 'form1.default-error',
    cpError: 'form1.default-cp-error',
    maxlength: '5'
  });
};
/**
 * @description funcion para obtener los modelos del fomulario
 * @param linkFormValue foumulario que se usa
 * @returns modelo de select
 */
const getMunicipality: (linkFormValue: string) => SelectModel = (linkFormValue: string): SelectModel => {
  return new SelectModel(
    setSelectModel([linkFormValue, 'insuredData', 'municipality'],
      setSelectValue('form1.municipality', 'form1.default-error'),
      setSelectOptions('', '', [])
    )
  );
};
/**
 * @description funcion para obtener los modelos del fomulario
 * @param linkFormValue foumulario que se usa
 * @returns modelo de input
 */
const getDirection: (linkFormValue: string) => InputModel = (linkFormValue: string): InputModel => {
  return new InputModel({
    linkFormPath: [linkFormValue, 'insuredData', 'direction'],
    label: 'form1.direction',
    required: true,
    requiredText: 'form1.default-error'
  });
};
/**
 * @description funcion para obtener los modelos del fomulario
 * @param linkFormValue foumulario que se usa
 * @returns modelo de input
 */
const getProvince: (linkFormValue: string) => InputModel = (linkFormValue: string): InputModel => {
  return new InputModel({
    linkFormPath: [linkFormValue, 'insuredData', 'province'],
    label: 'form1.province',
    required: true,
    requiredText: 'form1.default-error'
  });
};
/**
 * @description funcion para obtener los modelos del fomulario
 * @param linkFormValue foumulario que se usa
 * @returns modelo de select
 */
const getCountry: (linkFormValue: string) => SelectModel = (linkFormValue: string): SelectModel => {
  return new SelectModel(
    setSelectModel([linkFormValue, 'insuredData', 'country'],
      setSelectValue('form1.country', 'form1.default-error'),
      setSelectOptions('España', 'España',  [{ name: 'España', id: Numbers.number0 },
        { name: 'Rome', id: Numbers.number1 },
        { name: 'London', id: Numbers.number2 }])
    )
  );
};
/**
 * @description funcion para obtener los tabla de garantias
 * @param linkFormValue foumulario que se usa
 * @param guarantee garantia
 * @param limit limite
 * @returns modelo de tabla
 */
const getRow: (linkFormPath: any, guarantee: any, limit: any) => any = (linkFormPath: any, guarantee: any, limit: any): any => {
  return setTableRow(linkFormPath, guarantee, limit, new SelectModel(
    setSelectModel( linkFormPath, {}, setSelectOptions('', '',  commondRowLimits))
  ));
};
/**
 * @description prepareInsuredDate
 * @param linkFormValue foumulario que se usa
 * @returns formulario
 */
const prepareInsuredDate = (linkFormValue) => {
  return {
    typeOwner: getTypeOwner(linkFormValue),
    particular: getParticular(linkFormValue),
    bussines: getBussines(linkFormValue),
    documentType: getDocumentType(linkFormValue),
    documentNumber: getDocumentNumber(linkFormValue),
    firstSurname: getFirstSurname(linkFormValue),
    secondSurname: getSeccondSurname (linkFormValue),
    email: getEmail(linkFormValue),
    prefix: getPrefix(linkFormValue),
    telephone: getTelephone(linkFormValue),
    direction: getDirection(linkFormValue),
    postalCode: getDirecction(linkFormValue),
    municipality: getMunicipality(linkFormValue),
    province: getProvince(linkFormValue),
    country: getCountry(linkFormValue),
    sendAdvertisingInternationalSOS: getAdvertisingInternationalSOS(linkFormValue)
  };
};
/**
 * @description prepareInsuredListData
 * @param linkFormValue foumulario que se usa
 * @returns formulario
 */
const prepareInsuredListData = (linkFormValue) => {
  return {
    linkFormPath: [linkFormValue, 'insuredListData'],
    documentType: getListDataDocumentType(),
    documentNumber: getListDataDocumentNumber(),
    name: getListDataName(),
    firstSurname: getListDataFirstSurname(),
    secondSurname: getListDataSeccondSurname(),
    dateBorn: getDateBorn(),
    email: getListDataEmail()
  };
};
/**
 * @description prepareEmergencyContact
 * @param linkFormValue foumulario que se usa
 * @returns formulario
 */
const prepareEmergencyContact = (linkFormValue) => {
  return {
    name: getEmName(linkFormValue),
    firstSurname: getEmFirstSurname(linkFormValue),
    secondSurname: getEmSecondSurname(linkFormValue),
    prefix: getEMPrefix(linkFormValue),
    telephone: getEmTelephone(linkFormValue),
    relationWithInsured: getRelationWithInsured(linkFormValue),
    acceptTerms: getAcceptTerms(linkFormValue),
    adequacyOfProduct: getAdequacyOfProduct(linkFormValue),
    treatmentOfData: getTreatmentOfData(linkFormValue),
    // sendAdvertisingInternationalSOS: getAdvertisingInternationalSOS(linkFormValue) ,
    sendAdvertisingByThirdParties: getAdvertisingByThirdParties(linkFormValue) ,
    sendAdvertisingEventsAndNews: getAdvertisingEventsAndNews(linkFormValue)
  };
};
/**
 * @description prepareGuaranteeSelection
 * @param linkFormValue foumulario que se usa
 * @returns tabla de garantias
 */
const prepareGuaranteeSelection = (linkFormValue) => {
  return {
    linkFormPath: [linkFormValue, 'guaranteeSelection'],
    title: 'Seleccion de garantías',
    headerRows: {
      guarantee: 'Garantía',
      limit: 'Límite',
      extendGuarantee: 'Ampliar Límite',
      included: 'Incluido'
    },
    rows: [
      getRow([linkFormValue, 'guaranteeSelection', 'deathAndDisability'],
      'Fallecimiento e invalidez', '10.000€'),
      getRow([linkFormValue, 'guaranteeSelection', 'tripCancellation'],
      'Anulación de viaje', '1.000€'),
      getRow([linkFormValue, 'guaranteeSelection', 'lostOrStolenLuggage'],
      'Perdida o robo de equipajes', '600 €'),
      getRow([linkFormValue, 'guaranteeSelection', 'vacationRefund'],
      'Reembolso de vacaciones', '1.000 €')
    ]
  };
};
/**
 * @description formConfigCommond
 * @param linkFormValue foumulario que se usa
 * @param numToCkeck numToCkeck
 * @returns configuracion del formulario
 */
export const formConfigCommond: (linkFormValue: string, numToCkeck: number) => any = (linkFormValue: string, numToCkeck: number) => {
  const obj: any =  {
    currentStep: new BehaviorSubject(1),
    stepIncrement(): void {
      this.currentStep.pipe(
        take(1)
      ).subscribe(num => {
        let numero: number = num;
        if ( num !== numToCkeck ) {
          ++num;
          numero = num;
        }
        this.currentStep.next(numero);
      });
    },
    stepDecrement(): void {
      this.currentStep.pipe(
        take(1)
      ).subscribe(num => {
        let numero = 1;
        if ( num > 1) {
          --num;
          numero = num;
        }
        this.currentStep.next(numero);
      });
    },
    numberOfInsured: getNumberOfInsured(linkFormValue),
    insuredOlderThan70years: getInsuredOlderThan70years(linkFormValue),
    insuredsPlayRiskSports: getInsuredsPlayRiskSports(linkFormValue),
    allInsuredSameFamiliarUnit: getAllInsuredSameFamiliarUnit(linkFormValue),
    currentlyTraveling: getCurrentlyTraveling(linkFormValue),
    codePromotional: getCodePromotional(linkFormValue),
    hasPetsInsurance: getHasPetsInsurance(linkFormValue),
    hasCodeDerogation: getHasCodeDerogation(linkFormValue),
    derogationCodes: getDerogationCodes(linkFormValue),
    insuredData: prepareInsuredDate(linkFormValue),
    insuredListData: prepareInsuredListData(linkFormValue),
    emergencyContact: prepareEmergencyContact(linkFormValue),
    guaranteeSelection: prepareGuaranteeSelection(linkFormValue)
  };

  if (obj.insuredData.prefix.options.default.selected !== 'España (+34)') {
    obj.insuredData.telephone.maxlength = '13';
  }
  if (obj.emergencyContact.prefix.options.default.selected !== 'España (+34)') {
    obj.emergencyContact.telephone.maxlength = '13';
  }
  return obj;
};
